module.exports = __webpack_public_path__ + "img/40.d0c3672b.png";